import ProductCards from "./productCards";
import Footer from "./footer";
import Header from "./header";
import BlackPepper from '../images/spices/BlackPepper-2.png';
import Cardamom from "../images/spices/Cardamom-1.png";
import CinamonWhole from "../images/spices/CinamonWhole-1.png";
import RedChilliPowder from "../images/spices/RedChilliPowder-1.png";
import banner6 from '../images/banner6.png'

function Spices({addToCart}){
    const products = [
  {
    id: 5,
    name: "Black Pepper",
    image: BlackPepper,
    rating: "4.7 | 279 Reviews",
    tags: ["Spicy"],
    prices: ["Rs 299 (MRP 400)", "Rs 499 (MRP 600)"]
  },
  {
    id: 6,
    name: "Cardamom",
    image: Cardamom,
    rating: "4.8 | 184 Reviews",
    tags: ["Spicy"],
    prices: ["325g - Rs 299 (MRP 400)", "500g - Rs 399 (MRP 500)"]
  },
  {
    id: 7,
    name: "Cinamon Whole",
    image: CinamonWhole,
    rating: "4.7 | 180 Reviews",
    tags: ["Spicy"],
    prices: ["325g - Rs 299 (MRP 400)", "500g - Rs 399 (MRP 500)"]
  },
  {
    id: 8,
    name: "Red Chilli Powder",
    image: RedChilliPowder,
    rating: "4.8 | 101 Reviews",
    tags: ["Spicy"],
    prices: ["325g - Rs 299 (MRP 400)", "500g - Rs 399 (MRP 500)"]
  }
];
    return(
        <div>
            <Header title = {"Spices"} banner = {banner6} />
            <div>
                <ProductCards addToCart={addToCart} products={products}/>
            </div>
            <Footer/>
        </div>
    )
}

export default Spices;